// src/pages/CarDetail.jsx
import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { BsSpeedometer } from "react-icons/bs";
import {
  BiDroplet,
  BiColor,
  BiGasPump,
  BiChevronUp,
  BiChevronDown,
  BiCalendar,
  BiGroup,
  // BiDollar,
  // BiDollarCircle,
} from "react-icons/bi";
import ContactSellerModal from "../components/ContactSellerModal";
import ReservationModal from "../components/ReservationModal";
import { getCarById } from "../api/cars";
import LoadingSpinner from "../components/LoadingSpinner";
import AdditionalChargesModal from "../components/ui/AdditionalChargesModel";
import { ChevronLeftIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import { TbLocationFilled } from "react-icons/tb";
import whichCarShouldIBuy from "../assets/which-car-should-i-buy.webp";
import { FaPlus, FaMinus, FaCross } from "react-icons/fa";
import { createPortal } from "react-dom";
import { BsGrid3X3GapFill } from "react-icons/bs";
import { IoSpeedometer } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useQuery } from "@tanstack/react-query";
import { getWarrantyPackageByName } from "../api/warranties";
import AdminCheckoutModal from "../components/admin/AdminCheckoutModal";
import ExclusiveWD from "../assets/warranties/Exclusive Warranty First 2025 Booklet.pdf";
import PremierWD from "../assets/warranties/Premier Warranty First 2025 Booklet.pdf";
import IgnitionWD from "../assets/warranties/Ignition Warranty First 2025 Booklet.pdf";
import Dynamic from "../assets/warranties/Dynamic Warranty First 2025 Booklet.pdf";
import ExclusiveWithHybridWD from "../assets/warranties/Exclusive + Hybrid Electric Warranty First 2025 Booklet.pdf";
import PremierWithHybridWD from "../assets/warranties/Premier + Hybrid Electric Warranty First 2025 Booklet.pdf";
import FinanceCalculator from "../components/FinanceCalculator";
import { MdOutlineOndemandVideo } from "react-icons/md";

// ——— ImageCarousel stays unchanged ———
function ImageCarousel({ photos = [], isSold = false }) {
  const thumbRefs = useRef([]);
  const [idx, setIdx] = useState(0);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const prev = () => setIdx((i) => (i - 1 + photos.length) % photos.length);
  const next = () => setIdx((i) => (i + 1) % photos.length);

  useEffect(() => {
    const thumb = thumbRefs.current[idx];
    if (thumb) {
      thumb.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [idx]);

  if (!photos.length) {
    return (
      <div className="relative w-full h-[50vh] md:h-[625px] flex items-center justify-center rounded-md overflow-hidden">
        <img
          src="https://zorqkblobstorage.blob.core.windows.net/zorqkblobstorage/Zorqk-coming-soon.jpg"
          alt={isSold ? "Vehicle Sold" : "Default car"}
          className="absolute inset-0 w-full h-full object-cover border-[1px]"
        />
      </div>
    );
  }

  // if (isSold) {
  //   return (
  //     <div className="relative w-full h-[50vh] md:h-[625px] flex items-center justify-center rounded-md overflow-hidden">
  //       <img
  //         src={photos[0].url}
  //         alt={`Slide ${0 + 1}`}
  //         className="w-full h-full object-cover"
  //       />
  //       {isSold && (
  //         <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center z-10">
  //           <div className="bg-red-600 text-white px-12 py-6 rounded-lg font-bold text-4xl transform -rotate-12 shadow-2xl">
  //             SOLD
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // }

  return (
    <div className="space-y-4 z-50 relative">
      <div className="relative w-full h-[50vh] md:h-[500px] overflow-hidden rounded-md bg-surface">
        <img
          src={photos[idx].url}
          alt={`Slide ${idx + 1}`}
          className="w-full h-full object-cover"
        />
        <button
          onClick={() => setIsGalleryOpen(true)}
          className="absolute flex items-center gap-2 bottom-4 right-4 bg-black/50 text-white px-4 py-2 rounded-full"
        >
          <BsGrid3X3GapFill /> View Gallery
        </button>
      </div>
      <div className="relative">
        <button
          onClick={prev}
          className="absolute left-0 top-1/2 -translate-y-1/2 -ml-6 text-2xl text-white p-2 rounded-full z-10"
        >
          ‹
        </button>
        <div className="flex space-x-2 overflow-x-auto hide-scrollbar">
          {photos.map((photo, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              ref={(el) => (thumbRefs.current[i] = el)}
              className={`flex-shrink-0 w-40 h-28 rounded overflow-hidden ${
                i === idx
                  ? "ring-4 ring-accent ring-offset-2 ring-offset-white"
                  : "ring-2 ring-secondary-accent"
              }`}
            >
              <img
                src={photo.url}
                alt={`Thumb ${i + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
        <button
          onClick={next}
          className="absolute right-0 top-1/2 -translate-y-1/2 -mr-6 text-2xl text-white p-2 rounded-full z-10"
        >
          ›
        </button>
      </div>
      {isGalleryOpen &&
        createPortal(
          <div className="fixed inset-0 z-[9999] bg-[#1f2954]/90 flex items-center justify-center p-4">
            <button
              onClick={() => setIsGalleryOpen(false)}
              className="absolute top-4 right-4 text-white text-3xl"
            >
              <RxCross2 />
            </button>
            <div className="w-full max-w-4xl bg-white rounded-lg p-4 space-y-4">
              <div className="relative w-full h-[50vh] md:h-[450px] overflow-hidden rounded-md">
                <img
                  src={photos[idx].url}
                  alt={`Slide ${idx + 1}`}
                  className="w-full h-full object-contain"
                />
                <button
                  onClick={prev}
                  className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full"
                >
                  ‹
                </button>
                <button
                  onClick={next}
                  className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full"
                >
                  ›
                </button>
              </div>
              <div className="flex space-x-2 overflow-x-auto hide-scrollbar">
                {photos.map((photo, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    className={`flex-shrink-0 w-24 h-16 rounded overflow-hidden ${
                      i === idx ? "ring-2 ring-accent" : "ring-secondary-accent"
                    }`}
                  >
                    <img
                      src={photo.url}
                      alt={`Thumb ${i + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}

export default function CarDetail() {
  const navigate = useNavigate();
  const { carId } = useParams();
  const financeRef = useRef(null);

  const [car, setCar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [panel, setPanel] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [chargesOpen, setChargesOpen] = useState(false);
  const [reservationOpen, setReservationOpen] = useState(false);
  const [openDesc, setOpenDesc] = useState(true);
  const [openOverview, setOpenOverview] = useState(true);
  const [openCategories, setOpenCategories] = useState({});
  const [selectedTerm, setSelectedTerm] = useState("3"); // default term
  const [selectedOptionIdx, setSelectedOptionIdx] = useState(0); // default to first option
  // track whether the warranty panel is expanded
  const [warrantyOpen, setWarrantyOpen] = useState(false);
  // track whether we’ve added the warranty price into the total
  const [includeWarranty, setIncludeWarranty] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [financeData, setFinanceData] = useState(null);

  const drawerRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    getCarById(carId)
      .then(setCar)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [carId]);

  useEffect(() => {
    function handleClickOutside(evt) {
      if (
        panel &&
        drawerRef.current &&
        !drawerRef.current.contains(evt.target)
      ) {
        setPanel(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [panel]);

  const warrantyPackageName = car?.base?.warrantyPackage;
  const { data: warrantyData, isLoading: warrantyLoading } = useQuery({
    queryKey: ["warranty", warrantyPackageName],
    queryFn: () => getWarrantyPackageByName(warrantyPackageName),
    enabled: !!warrantyPackageName,
  });

  if (loading) return <LoadingSpinner />;
  if (error) return <p className="text-danger text-center py-8">{error}</p>;
  if (!car) return <p className="text-center py-8">Car not found.</p>;

  // ——— Pull everything from your new model ———
  const {
    // your base CSV fields
    base: {
      co2,
      color,
      estP11D,
      extras,
      group,
      mileage,
      modelDescription,
      plate,
      regDate,
      registration,
      status,
      price,
      images,
      interiorFeatures,
      videoLink,
    } = {},

    // the new API payload
    extended: {
      //vehicle details
      make = "",
      model = "",
      extColor = "",
      co2Emissions = "",
      fuel = "",
      cylinderCapacity = "",
      year,
      revenueWeight,
      wheelPlan,
      euroStatus,
      isSorn,

      //other extended
      bodyStyle = "",
      transmissionType,
      bhp,
      cylinders,
      euroStandard,
      exactCc,
      doors,
      seats,
      gears,
      extMake,
      extModel, //correct model
      valves,
      wheelbaseMm,
      maxNetPower, //engine power
      height,
      length,
      width,
      acceleration0To62Mph,
      maxSpeedMph,

      //extended dvla
      engineSizeLitres,
      vin,
      vrm,
    } = {},
  } = car;

  // console.log("car info", car);
  const rateExVAT = car?.rateExVAT ?? 0;

  const toggleCategory = (cat) =>
    setOpenCategories((prev) => ({ ...prev, [cat]: !prev[cat] }));

  // — build exactly two spec-groups for our new panel —
  const specGroups = {
    Performance: [
      {
        key: "acceleration0To62Mph",
        label: "0-62 mph",
        value: acceleration0To62Mph ? `${acceleration0To62Mph} seconds` : "—",
      },
      {
        key: "maxSpeedMph",
        label: "Top speed",
        value: maxSpeedMph ? `${maxSpeedMph} mph` : "—",
      },
      {
        key: "cylinders",
        label: "Cylinders",
        value: cylinders ?? "—",
      },
      {
        key: "valves",
        label: "Valves",
        value: valves ?? "—",
      },
      {
        key: "maxNetPower",
        label: "Engine power",
        value: maxNetPower ? `${maxNetPower} BHP` : "—",
      },
      // if your API returns torque, e.g. engineTorqueNm:
      // {
      //   key: "engineTorqueNm",
      //   label: "Engine torque",
      //   value: engineTorqueNm ? `${engineTorqueNm} NM` : "—",
      // },
      // if your API returns a mpg field:
      // {
      //   key: "mpg",
      //   label: "Miles per gallon",
      //   value: mpg ? `${mpg} mpg` : "—",
      // },
    ],
    "Size & Dimensions": [
      {
        key: "height",
        label: "Height",
        value: height ? `${height} mm` : "—",
      },
      {
        key: "length",
        label: "Length",
        value: length ? `${length} mm` : "—",
      },
      {
        key: "width",
        label: "Width",
        value: width ? `${width} mm` : "—",
      },
      // {
      //   key: "groundClearanceMm",
      //   label: "Ground clearance",
      //   value: groundClearanceMm ? `${groundClearanceMm} mm` : "—",
      // },
      {
        key: "wheelbaseMm",
        label: "Wheelbase",
        value: wheelbaseMm ? `${wheelbaseMm} mm` : "—",
      },
      // {
      //   key: "seats",
      //   label: "Seats",
      //   value: seats ?? "—",
      // },
      // {
      //   key: "fuelTankCapacityLitres",
      //   label: "Fuel tank capacity",
      //   value: fuelTankCapacityLitres ? `${fuelTankCapacityLitres} L` : "—",
      // },
      // {
      //   key: "bootSpaceSeatsDownLitres",
      //   label: "Boot space (seats down)",
      //   value: bootSpaceSeatsDownLitres ? `${bootSpaceSeatsDownLitres} L` : "—",
      // },
      // {
      //   key: "bootSpaceSeatsUpLitres",
      //   label: "Boot space (seats up)",
      //   value: bootSpaceSeatsUpLitres ? `${bootSpaceSeatsUpLitres} L` : "—",
      // },
      // {
      //   key: "minKerbWeightKg",
      //   label: "Minimum kerb weight",
      //   value: minKerbWeightKg ? `${minKerbWeightKg} kg` : "—",
      // },
    ],
  };

  // features: unchanged from your array logic
  const featuresByCategory = interiorFeatures?.length
    ? interiorFeatures.reduce((acc, { category, features }) => {
        acc[category] = features.map((name) => ({ name }));
        return acc;
      }, {})
    : {};

  // sort by isPrimary desc, then position asc
  const sortedPhotos = (images || [])
    .slice() // don’t mutate original
    .sort((a, b) => {
      // primary first
      if (a.isPrimary !== b.isPrimary) {
        return b.isPrimary - a.isPrimary;
      }
      // then by position
      return a.position - b.position;
    });

  const warrantyPackage = warrantyData?.[0]; // or null if not found
  const selectedWarrantyTerm = warrantyPackage?.terms?.find(
    (t) => t.term === Number(selectedTerm)
  );
  const selectedOption =
    selectedWarrantyTerm?.options?.[selectedOptionIdx] ?? null;

  const basePriceNumber = price ?? 0;
  const warrantyPriceNumber = selectedOption?.price ?? 0;
  const vatAmount = warrantyPriceNumber * 0.2;
  const totalPrice =
    basePriceNumber + (includeWarranty ? warrantyPriceNumber + vatAmount : 0);

  // console.log(car);

  // 1) Helper to choose the right PDF:
  const getWarrantyPdf = () => {
    if (!warrantyPackage) return null;
    const pkg = warrantyPackage.packageName; // e.g. "Exclusive", "Dynamic", "Ignition", "Premier"
    const isHybrid =
      fuel === "Electric" || fuel === "Hybrid" || fuel === "Electricity";

    if (pkg === "Exclusive" && isHybrid) return ExclusiveWithHybridWD;
    if (pkg === "Premier" && isHybrid) return PremierWithHybridWD;

    switch (pkg) {
      case "Exclusive":
        return ExclusiveWD;
      case "Dynamic":
        return Dynamic;
      case "Ignition":
        return IgnitionWD;
      case "Premier":
        return PremierWD;
      default:
        return null;
    }
  };

  const warrantyPdf = getWarrantyPdf();

  // Compute warranty and price breakdown
  const warrantySummary = selectedOption
    ? (() => {
        const warrantyBasePrice = selectedOption.price;
        const vatAmount = warrantyBasePrice * 0.2;
        const totalWarrantyPrice = warrantyBasePrice + vatAmount;
        return {
          packageName: warrantyPackage?.packageName || "-",
          term: selectedTerm,
          perRepairCover: selectedOption.perRepairLimit,
          warrantyPrice: warrantyBasePrice.toFixed(2),
          vatAmount: vatAmount.toFixed(2),
          totalWarrantyPrice: totalWarrantyPrice.toFixed(2),
        };
      })()
    : null;

  // Vehicle price info
  const vehiclePriceInfo = {
    basePrice: basePriceNumber.toFixed(2),
    includeWarranty: includeWarranty,
    totalPrice: totalPrice.toFixed(2),
  };

  const handleOpenModal = (data) => {
    setFinanceData(data); // save selected finance details
    setModalOpen(true); // open modal
  };

  return (
    <>
      {/* Hero */}
      <section
        className="
    relative w-full h-fit flex flex-col gap-10 text-white overflow-hidden
    px-4 sm:px-6 lg:px-20
    py-12 sm:py-20 lg:py-32
  "
      >
        {" "}
        <div
          className="absolute inset-0 z-0"
          style={{ background: "linear-gradient(#1f2954 10%, #ef514b 77%)" }}
        />
        <Link
          to="/used-cars"
          className="z-10 flex items-center gap-3 mt-10 text-accent hover:underline"
        >
          <ChevronLeftIcon className="size-5" /> Back to results
        </Link>
        <div className="flex flex-col gap-10 md:flex-row md:gap-10 mb-20 md:mb-10">
          <div className="w-full md:w-3/5 z-10">
            <div className="flex flex-col md:flex-row justify-between items-center pb-4">
              <div className="w-[70%]">
                <h2 className="text-base md:text-lg font-bold  text-white">
                  All our cars are VAT qualifying
                </h2>
                <p className="md:hidden text-white text-sm mt-1">
                  📞 Call us ·{" "}
                  <a href="tel:03337723333" className="underline hover:text-gray-200">
                    0333 772 3333
                  </a>
                </p>
              </div>

              {videoLink ? (
                <div className="text-right w-[30%]">
                  <a
                    href={videoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-1 px-4 rounded-md border border-gray-300 shadow-sm transition duration-200"
                  >
                    <div className="flex gap-2 justify-center items-center">
                      <MdOutlineOndemandVideo />
                      Watch Video
                    </div>
                  </a>
                </div>
              ) : null}
            </div>

            <ImageCarousel photos={sortedPhotos} isSold={status === "sold"} />
          </div>

          {/* Hero Right Side  */}
          <div className="flex flex-col gap-5 w-full md:w-2/5 z-10">
            {/* Tags  */}
            <div className="space-y-2">
              {/* Heading  */}
              <h2 className="text-4xl font-extrabold text-on-surface">
                {make} {extModel || model}
              </h2>
              <p className="text-md text-white-accent">
                {modelDescription || extModel || model}
              </p>

              {/* Tags Starting  */}
              <div className="flex flex-wrap gap-2 mt-2">
                {mileage != null && (
                  <span className="px-3 py-1 bg-lightGray text-on-surface rounded-full text-xs">
                    {mileage.toLocaleString()} miles
                  </span>
                )}

                {year && (
                  <span className="px-3 py-1 bg-lightGray text-on-surface rounded-full text-xs">
                    {year} ({plate}reg)
                  </span>
                )}

                {transmissionType && (
                  <span className="px-3 py-1 bg-lightGray text-on-surface rounded-full text-xs">
                    {transmissionType}
                  </span>
                )}

                {/* {fuel && (
                  <span className="px-3 py-1 bg-lightGray text-on-surface rounded-full text-sm">
                    {fuel}
                  </span>
                )} */}
                {/* {cylinderCapacity && (
                  <span className="px-3 py-1 bg-lightGray text-on-surface rounded-full text-sm">
                    {(cylinderCapacity / 1000).toFixed(1)}L
                  </span>
                )} */}
                {color && (
                  <span className="px-3 py-1 bg-lightGray text-on-surface rounded-full text-xs">
                    {extColor || color}
                  </span>
                )}
              </div>
            </div>

            {/* Quick Info */}
            <div className="bg-transparent p-4 rounded-md border">
              <h4 className="font-semibold mb-7 text-on-surface">Quick Info</h4>
              <dl className="text-sm space-y-3 text-on-surface">
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <BsSpeedometer /> Mileage
                  </dt>
                  <dd>{mileage.toLocaleString()} mi</dd>
                </div>
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <BiDroplet /> Fuel
                  </dt>
                  <dd>{fuel}</dd>
                </div>
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <BiColor /> Colour
                  </dt>
                  <dd>{extColor || color}</dd>
                </div>
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <BiGasPump /> CO₂ (g/km)
                  </dt>
                  {/* TODO  */}
                  <dd>{co2 || co2Emissions}</dd>
                </div>
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <BiGasPump /> P11D
                  </dt>
                  {/* TODO  */}
                  <dd>£{estP11D || "0"}</dd>
                </div>
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <BiCalendar /> Year
                  </dt>
                  <dd>{year}</dd>
                </div>
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <BiGroup /> Seats
                  </dt>
                  <dd>{seats}</dd>
                </div>
                <div className="flex justify-between items-center">
                  <dt className="flex items-center gap-1 text-white">
                    <IoSpeedometer /> Engine
                  </dt>
                  <dd>
                    {engineSizeLitres || (cylinderCapacity / 1000).toFixed(1)}L
                  </dd>
                </div>
              </dl>
            </div>

            {/* Contact Us / P11D */}
            <div className="bg-white p-4 rounded-md shadow">
              {/* Total price */}
              <div className="text-2xl font-bold text-accent">
                £{totalPrice.toLocaleString()}
              </div>

              {status === "sold" && (
                <div className="mt-4 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-4 py-3 text-center">
                  ⚠️ This vehicle has been <strong>SOLD</strong> and is no
                  longer available for purchase.
                </div>
              )}

              {/* Buttons – flex wrap + gap + margin-top */}
              <div className="flex flex-wrap gap-2 mt-4">
                {/* Pay in full */}
                <button
                  onClick={() => setCheckoutOpen(true)}
                  disabled={status === "sold"}
                  className={`flex-1 min-w-[120px] py-2 rounded transition inline-flex items-center justify-center gap-2 ${
                    status === "sold"
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-accent text-white hover:opacity-90"
                  }`}
                >
                  Pay in full
                </button>

                {/* Reserve */}
                <button
                  onClick={() => setReservationOpen(true)}
                  disabled={status === "sold"}
                  className={`flex-1 min-w-[120px] py-2 rounded transition inline-flex items-center justify-center gap-2 ${
                    status === "sold"
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-accent text-white hover:opacity-90"
                  }`}
                >
                  Reserve at £99
                </button>

                {/* Add Warranty */}
                <button
                  onClick={() => setWarrantyOpen((o) => !o)}
                  disabled={status === "sold"}
                  className={`flex-1 min-w-[120px] py-2 rounded transition inline-flex items-center justify-center gap-2 ${
                    status === "sold"
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-accent text-white hover:opacity-90"
                  }`}
                >
                  Add Warranty
                </button>

                {/* Finance */}
                <button
                  onClick={() => {
                    const el = document.getElementById('finance-calculator-section');
                    if (el) {
                      el.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  disabled={status === "sold"}
                  className={`flex-1 min-w-[120px] py-2 rounded transition inline-flex items-center justify-center gap-2 text-center ${
                    status === "sold"
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed pointer-events-none"
                      : "bg-accent text-white hover:opacity-90"
                  }`}
                  tabIndex={status === "sold" ? -1 : 0}
                  type="button"
                >
                  Finance
                </button>

                {/* <button
                  onClick={() => setModalOpen(true)}
                  className="flex-1 min-w-[120px] py-2 bg-accent text-white rounded hover:opacity-90 transition inline-flex items-center justify-center gap-2"
                >
                  <BiDollarCircle className="ml-2" />
                  Get Finance Prices
                </button> */}
              </div>

              <div className="flex flex-wrap gap-2 mt-2">
                {/* Enquire Now */}
                <button
                  onClick={() => setModalOpen(true)}
                  disabled={status === "sold"}
                  className={`flex-1 min-w-[120px] py-2 rounded transition inline-flex items-center justify-center gap-2 ${
                    status === "sold"
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-accent text-white hover:opacity-90"
                  }`}
                >
                  <TbLocationFilled className="ml-2" />
                  Enquire now
                </button>

                {/* Attractive Note */}
                {status !== "sold" && (
                  <div className="w-full bg-blue-50 border border-blue-100 text-blue-700 text-sm rounded-lg px-4 py-2 mt-2 text-center shadow-sm">
                    💡 Have questions about{" "}
                    <span className="font-semibold">full payment</span> or{" "}
                    <span className="font-semibold">finance options</span>?
                    <br />
                    Fill out our{" "}
                    <span className="font-medium">enquiry form</span>!
                  </div>
                )}
              </div>
            </div>

            {warrantyOpen && warrantyData && selectedWarrantyTerm && (
              <div className="bg-transparent p-4 rounded-md border shadow mt-4">
                <div className="flex justify-between items-center mb-5">
                  <h4 className="font-bold text-on-surface text-lg">
                    Warranty Package:{" "}
                    <span className="text-primary">
                      {warrantyPackage.packageName}
                    </span>
                  </h4>
                  {warrantyPdf && (
                    <a
                      href={warrantyPdf}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center text-primary hover:underline text-sm font-medium"
                    >
                      <DocumentTextIcon className="h-4 w-4 mr-1" />
                      Details
                    </a>
                  )}
                </div>

                {/* Term & Cover selects */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Select Term */}
                  <div>
                    <label
                      htmlFor="warranty-term"
                      className="block mb-1 text-base"
                    >
                      Select Term
                    </label>
                    <select
                      id="warranty-term"
                      className="text-primary w-full border rounded px-2 py-1"
                      value={selectedTerm}
                      onChange={(e) => {
                        setSelectedTerm(e.target.value);
                        setSelectedOptionIdx(0);
                      }}
                    >
                      {warrantyPackage.terms.map((term) => (
                        <option key={term.term} value={term.term}>
                          {term.term} months
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Select Per Repair Cover instead of Price */}
                  {selectedWarrantyTerm.options.length > 0 && (
                    <div>
                      <label
                        htmlFor="warranty-option"
                        className="block mb-1 text-base"
                      >
                        Select Per Repair Cover
                      </label>
                      <select
                        id="warranty-option"
                        className="text-primary w-full border rounded px-2 py-1"
                        value={selectedOptionIdx}
                        onChange={(e) =>
                          setSelectedOptionIdx(Number(e.target.value))
                        }
                      >
                        {selectedWarrantyTerm.options.map((opt, idx) => (
                          <option key={idx} value={idx}>
                            £{opt.perRepairLimit}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

                {/* Show corresponding price */}
                {/* <p className="text-lg text-primary mt-4">
                  Price:{" "}
                  <span className="font-semibold">£{selectedOption.price}</span>
                </p> */}

                {/* Show corresponding price and VAT summary */}
                {/* Simplified Total Price Display */}
                <div className="mt-5 bg-gray-50 border rounded-lg p-4 shadow-sm">
                  <h5 className="font-semibold text-primary mb-3">
                    Warranty Price
                  </h5>

                  {/* Calculate Values */}
                  {(() => {
                    const basePrice = selectedOption.price;
                    const vatAmount = basePrice * 0.2;
                    const total = basePrice + vatAmount;
                    return (
                      <p className="text-lg text-on-surface">
                        <span className="font-semibold text-primary">
                          Total Price: £{total.toFixed(2)}
                        </span>{" "}
                        <span className="text-sm text-gray-600">
                          (includes £{vatAmount.toFixed(2)} VAT at 20%)
                        </span>
                      </p>
                    );
                  })()}
                </div>

                {/* Buttons */}
                <div className="flex flex-wrap gap-4 mt-4">
                  {!includeWarranty ? (
                    <button
                      onClick={() => setIncludeWarranty(true)}
                      className="flex-1 min-w-[150px] py-2 bg-green-100 text-green-800 rounded inline-flex items-center justify-center gap-2 text-sm"
                    >
                      Add Warranty (+£
                      {parseFloat(selectedOption.price + vatAmount).toFixed(2)})
                    </button>
                  ) : (
                    <button
                      onClick={() => setIncludeWarranty(false)}
                      className="flex-1 min-w-[150px] py-2 bg-red-100 text-red-800 rounded inline-flex items-center justify-center gap-2 text-sm"
                    >
                      Remove Warranty (-£
                      {parseFloat(selectedOption.price + vatAmount).toFixed(2)})
                    </button>
                  )}

                  <button
                    onClick={() => setWarrantyOpen(false)}
                    className="flex-1 min-w-[100px] py-2 bg-gray-200 text-gray-800 rounded inline-flex items-center justify-center gap-2 text-sm"
                  >
                    <RxCross2 /> Cancel
                  </button>
                </div>

                <p className="text-sm italic mt-2">
                  *Warranty starts from date of purchase.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Description & Overview */}
      <section className="relative -mt-20 bg-white text-primary py-20 rounded-3xl md:rounded-t-[50px] z-30 px-4 xl:px-0">
        {/* Description */}
        <div className="max-w-5xl mx-auto flex flex-col gap-6 pb-10">
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() => setOpenDesc((o) => !o)}
          >
            <h3 className="text-3xl text-accent font-bold">Description</h3>
            {openDesc ? (
              <FaMinus className="text-accent" />
            ) : (
              <FaPlus className="text-accent" />
            )}
          </div>

          {/* TODO : Need this description */}
          {openDesc && (
            <>
              <p>{modelDescription}</p>
            </>
          )}
        </div>
        <hr className="max-w-5xl bg-primary mx-auto h-[3px] rounded-full" />

        {/* Car Overview */}
        <div className="mt-6 max-w-5xl mx-auto">
          <div
            className="flex justify-between items-center cursor-pointer mb-10"
            onClick={() => setOpenOverview((o) => !o)}
          >
            <h3 className="text-3xl text-accent font-bold">Car Overview</h3>
            {openOverview ? (
              <FaMinus className="text-accent" />
            ) : (
              <FaPlus className="text-accent" />
            )}
          </div>

          {openOverview && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 md:gap-16 text-sm">
              {/* Basic */}
              <div>
                <h4 className="font-semibold text-accent mb-2 border-b-2 border-accent pb-1">
                  Basic
                </h4>
                <dl className="mt-2">
                  {mileage && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Mileage</dt>
                      <dd>{mileage.toLocaleString()} miles</dd>
                    </div>
                  )}
                  <div className="flex justify-between py-2 border-b border-secondary-accent">
                    <dt>Registration</dt>
                    <dd>
                      {year} ({plate}reg)
                    </dd>
                  </div>
                  <div className="flex justify-between py-2 border-b border-secondary-accent">
                    <dt>CO₂ (g/km)</dt>
                    <dd>{co2 || co2Emissions}</dd>
                  </div>
                  {fuel && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Fuel type</dt>
                      <dd>{fuel}</dd>
                    </div>
                  )}
                  {bodyStyle && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Body type</dt>
                      <dd>{bodyStyle}</dd>
                    </div>
                  )}
                  {color && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Colour</dt>
                      <dd>{extColor || color}</dd>
                    </div>
                  )}
                </dl>
              </div>

              {/* Extended */}
              <div>
                <h4 className="font-semibold text-accent mb-2 border-b-2 border-accent pb-1">
                  Extended
                </h4>
                <dl className="mt-2">
                  {transmissionType && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Gearbox</dt>
                      <dd>{transmissionType}</dd>
                    </div>
                  )}
                  {cylinderCapacity && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Engine</dt>
                      <dd>
                        {engineSizeLitres ||
                          (cylinderCapacity / 1000).toFixed(1)}
                        L
                      </dd>
                    </div>
                  )}
                  {doors && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Doors</dt>
                      <dd>{doors}</dd>
                    </div>
                  )}
                  {seats && (
                    <div className="flex justify-between py-2 border-b border-secondary-accent">
                      <dt>Seats</dt>
                      <dd>{seats}</dd>
                    </div>
                  )}
                  <div className="flex justify-between py-2 border-b border-secondary-accent">
                    <dt>P11D</dt>
                    <dd>{estP11D != null ? `£${estP11D}` : "-"}</dd>
                  </div>
                  <div className="flex justify-between py-2 border-b border-secondary-accent">
                    <dt>Emission Class</dt>
                    <dd>{euroStandard}</dd>
                  </div>
                </dl>
              </div>

              {/* Car Specs Fields */}
              {Object.entries(specGroups).map(([section, items]) => (
                <div key={section}>
                  <h4 className="font-semibold text-accent mb-2 border-b-2 border-accent pb-1">
                    {section}
                  </h4>
                  <dl className="mt-2">
                    {items
                      .filter(({ value }) => value != null && value !== "—")
                      .map(({ key, label, value }) => (
                        <div
                          key={key}
                          className="flex justify-between py-2 border-b border-secondary-accent"
                        >
                          <dt>{label}</dt>
                          <dd>{value}</dd>
                        </div>
                      ))}
                  </dl>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Panel Buttons */}
        <div className="mt-16 flex justify-center space-x-4">
          {/* <button
            onClick={() => setPanel("specs")}
            className="px-6 md:px-12 py-1 md:py-2 bg-accent text-white rounded-full font-bold hover:bg-accent/90 transition"
          >
            Car Specs
          </button> */}

          <button
            onClick={() => setPanel("features")}
            className="px-6 md:px-12 py-1 md:py-2 border border-accent text-accent font-bold rounded-full hover:bg-accent/90 transition"
          >
            Car Features
          </button>
        </div>
      </section>

      {/* Sidebar for Specs & Features */}
      {panel && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* BACKDROP */}
          <div
            className="absolute inset-0 bg-[#1f2954]/90"
            onClick={() => setPanel(null)}
          />

          {/* MODAL WINDOW */}
          <div className="relative bg-white text-primary w-full max-w-3xl rounded-2xl overflow-hidden px-5">
            {/* HEADER */}
            <div className="mx-6 py-4 flex justify-between items-center border-b-2">
              <h3 className="text-2xl font-bold text-accent">
                {panel === "specs" ? "Car Specs" : "Car Features"}
              </h3>
              <button
                onClick={() => setPanel(null)}
                className="p-2 text-xl leading-none"
              >
                <RxCross2 />
              </button>
            </div>

            {/* SCROLLABLE CONTENT */}
            <div className="p-6 max-h-[70vh] overflow-y-auto space-y-6">
              {/* {panel === "specs" &&
                Object.entries(specGroups).map(([section, items]) => {
                  // drop anything with no real value (we use "—" as our placeholder)
                  const visible = items.filter(
                    ({ value }) => value != null && value !== "—"
                  );
                  // if this entire section wound up empty, skip it
                  if (!visible.length) return null;

                  return (
                    <div key={section} className="space-y-3">
                      <button
                        onClick={() => toggleCategory(section)}
                        className="w-full flex justify-between items-center font-bold border-b-2 border-accent pb-1"
                      >
                        {section}
                        {openCategories[section] ? (
                          <BiChevronUp className="text-lg text-accent" />
                        ) : (
                          <BiChevronDown className="text-lg text-accent" />
                        )}
                      </button>
                      {openCategories[section] && (
                        <dl className="mt-2 space-y-2 text-sm">
                          {visible.map(({ key, label, value }) => (
                            <div
                              key={key}
                              className="flex justify-between items-center"
                            >
                              <dt>{label}</dt>
                              <dd>{value}</dd>
                            </div>
                          ))}
                        </dl>
                      )}
                    </div>
                  );
                })} */}

              {panel === "features" &&
                Object.entries(featuresByCategory).map(([category, feats]) => (
                  <div key={category} className="space-y-3">
                    <button
                      onClick={() => toggleCategory(category)}
                      className="w-full flex justify-between items-center font-bold border-b-2 border-accent pb-1"
                    >
                      {category}
                      {openCategories[category] ? (
                        <BiChevronUp className="text-lg text-accent" />
                      ) : (
                        <BiChevronDown className="text-lg text-accent" />
                      )}
                    </button>
                    {openCategories[category] && (
                      <ul className="mt-2 space-y-1 text-sm">
                        {feats.map((f) => (
                          <li key={f.name} className="flex justify-between">
                            <span>{f.name}</span>
                            {f.type === "Optional" && (
                              <em className="text-xs">(Optional)</em>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      {/* {status !== "sold" && ( */}
      <div id="finance-calculator-section">
        <FinanceCalculator
          ref={financeRef}
          carPrice={price ?? 0}
          defaultDeposit={parseInt(price * 0.1)}
          onRequestFinance={handleOpenModal} // pass handler to child
          isSold={status === "sold"}
        />
      </div>
      {/* )} */}

      {/* Help Section */}
      <section className="bg-primary py-32 px-6 relative pb-80 -mb-60">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-20 ">
          <div className="flex flex-col gap-2">
            <h2 className="text-accent text-3xl md:text-4xl font-bold mb-10">
              Need help finding your next car?
            </h2>
            <p className="text-white font-semibold mb-4">
              Contact us to and go from 1000s of cars to just a handful of
              recommendations.
            </p>
            <p className="text-white text-base leading-relaxed">
              Go on, ZORQK your search.
            </p>
            <button
              onClick={() => navigate("/used-cars")}
              className="px-12 py-2 bg-accent text-white rounded-full font-bold hover:bg-accent/90 transition mt-8"
            >
              Get Started
            </button>
          </div>
          <div>
            <img
              src={whichCarShouldIBuy}
              alt="What drives us"
              className="w-full h-auto rounded-3xl object-cover"
            />
          </div>
        </div>
      </section>

      <ContactSellerModal
        open={modalOpen}
        ref={financeRef}
        financeData={financeData}
        onClose={() => {
          setModalOpen(false);
          setIncludeWarranty(false);
          setWarrantyOpen(false);
        }}
        vehicleId={car?._id}
        regNumber={registration}
        make={make}
        model={model}
        mileage={mileage}
        includeWarranty={includeWarranty}
        warrantySummary={warrantySummary || {}}
        vehiclePriceInfo={vehiclePriceInfo}
      />

      <AdditionalChargesModal
        open={chargesOpen}
        onClose={() => setChargesOpen(false)}
      />

      <AdminCheckoutModal
        open={checkoutOpen}
        onClose={() => setCheckoutOpen(false)}
        carId={car.base.id}
        basePrice={price}
        includeWarranty={includeWarranty}
        warrantyPackageName={warrantyPackage?.packageName}
        warrantyTerm={Number(selectedTerm)}
        warrantyOption={selectedOption}
        totalPrice={totalPrice}
      />

      <ReservationModal
        open={reservationOpen}
        onClose={() => setReservationOpen(false)}
        car={car}
      />
    </>
  );
}
